import { UserParticipant } from "./UserParticipant";

export class PositionParticipant extends UserParticipant {
    positionType: string;
    isRequired?: boolean;
}